var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":13,"map-type-id":"hybrid","options":{
        styles: [
            { featureType: 'all', stylers: [{ visibility: 'off' }] },
            { featureType: 'road', stylers: [{ visibility: 'on' }] },
            { featureType: 'water', stylers: [{ visibility: 'on' }] },
            { featureType: 'landscape', stylers: [{ visibility: 'on' }] },
            { featureType: 'administrative', stylers: [{ visibility: 'on' }] } ],
        gestureHandling: 'cooperative',
      }},on:{"click":_vm.setPosition}},[(_vm.position)?_c('GmapMarker',{attrs:{"position":_vm.position,"draggable":true},on:{"dragend":_vm.setPosition}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }